/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { LoggerService } from '../../../shared/services/logger.service';
import { Store } from '@ngxs/store';
import { ReportContentBaseComponent } from '../report-content-base.component';
import { IsolatedReportService } from '../../services/isolatedReport.service';
import { isEqual } from 'lodash-es';

@Component({
    selector: 'dash-gis-report-content-pdf',
    template: '<ng-container></ng-container>',
})
export class ReportContentPdfComponent extends ReportContentBaseComponent implements OnChanges {
    constructor(logger: LoggerService, isolatedReportService: IsolatedReportService, private store: Store) {
        super(logger, isolatedReportService);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.definition && !isEqual(changes.definition.previousValue, changes.definition.currentValue)) {
            this.isolatedReportService.triggerAllData();
        }
    }
}
